/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MealDeliveryPatientAliases {
  CARD_CONTAINER_0 = 'card-container-0',
  CARD_CONTAINER_BODY = 'card-container-body',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_TEXT = 'date-text',
  DESCRIPTION = 'description',
  DT_SERVICE_FORMAT_FIELD = 'dtServiceFormat-field',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  ICON_MAPPER = 'icon-mapper',
  INFO_CARD_CONTAINER_ZONE = 'info-card-container-zone',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  LAYOUT_MEAL_DELIVERY_PATIENT = 'layout-meal-delivery-patient',
  LEGENDS_MAIN = 'legends-main',
  MAIN_CARD_CONTAINER_ZONE = 'main-card-container-zone',
  MEALS_FETCH = 'meals-fetch',
  MEALS_FETCH_DECK = 'meals-fetch-deck',
  MEALS_FETCH_MAPPER = 'meals-fetch-mapper',
  PANEL_LIST_MEALS_TO_DELIVERY = 'panel-list-meals-to-delivery',
  REGISTER_MEAL_DELIVERY_BUTTON = 'register-meal-delivery-button',
  SEQUENCE_FIELD = 'sequence-field',
  SEQUENCE_TEXT = 'sequence-text',
  SERVICE_DESCRIPTION_FIELD = 'service-description-field',
  STATUS_CARD_CONTAINER_ZONE = 'status-card-container-zone',
  STATUS_ICON_SWITCHER = 'status-icon-switcher',
}
export { MealDeliveryPatientAliases };
